import { Directive, ElementRef, Renderer2, Optional } from '@angular/core';
import { NglPill } from './pill';
var NglPillLink = (function () {
    function NglPillLink(pill, element, renderer) {
        if (!pill)
            return;
        renderer.addClass(element.nativeElement, 'slds-pill__label');
        pill.unlinked = false;
    }
    NglPillLink.decorators = [
        { type: Directive, args: [{
                    selector: 'a',
                },] },
    ];
    /** @nocollapse */
    NglPillLink.ctorParameters = function () { return [
        { type: NglPill, decorators: [{ type: Optional },] },
        { type: ElementRef, },
        { type: Renderer2, },
    ]; };
    return NglPillLink;
}());
export { NglPillLink };
//# sourceMappingURL=pill-link.js.map